/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(data) {
  var deferred = $.Deferred();
  $.soap({
    body: {
      SubmitUserComplianceRegistration: {
        $xmlns: 'http://dobs.pa.gov/sc/usercomplianceregistration/bpm/1.0',
        FirstName: data.firstName,
        LastName: data.lastName,
        Title: data.title,
        ProfessionalTypeID: data.professionalTypeID,
        Organization: data.organization,
        Email: data.email,
        Phone: data.phone,
        Address: {
          AddressLine1: data.addressLine1,
          AddressLine2: data.addressLine2,
          County: data.county,
          City: data.city,
          State: data.state,
          PostalCode: data.postalCode,
          Country: data.country
        },
        SpecialAccommodations: data.specialAccommodations,
        DietaryRestrictions: data.dietaryRestrictions,
        PAAB: data.paab,
        PACLEB: data.pacleb,
        CFPBOS: data.cfpbos,
        PADOI: data.padoi,
        ACCFC: data.accfc,
        IsPaid: data.isPaid,
        IsInternal: data.isInternal,
        IsDeleted: data.isDeleted,
        ComplianceRegistrationID: data.complianceRegistrationId
      }
    },
    blueprint: {
      id: '$..ID.__text'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response.id);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
